module.exports = __webpack_public_path__ + "img/consult_info4.cb5f59c9.png";